import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ELinesActions, GetLines, GetLinesSuccess, GetLinesFailure } from '../actions/lines.actions';
import { LinesService } from '../../services/lines.service';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { LineInterface } from '../../models/line.interface';

@Injectable()
export class LinesEffects extends AbstractEffects {

    constructor(
      private actions: Actions,
      private linesService: LinesService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getLines = createEffect(() => this.actions.pipe(
        ofType<GetLines>(ELinesActions.GetLines),
        switchMap(() => this.linesService.get()),
        switchMap((response: Array<LineInterface>) => of(new GetLinesSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetLines());
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetLinesFailure());
            }
            return throwError(error);
        })
    ));
}
